<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="4"
        :md="6"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-input
          style="width: 100%;"
          v-model="botName"
          placeholder="服务器名称"
          clearable
        ></el-input>
      </el-col>
      <el-col
        :lg="4"
        :md="6"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          style="width: 100%"
          placeholder="登录状态查询"
          v-model="status"
          class=""
          clearable
          @change="selectChange"
        >
          <el-option
            v-for="(item,index) in statusList"
            :key="index"
            :label="item.name"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="6"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          style="width: 100%"
          placeholder="监听状态查询"
          v-model="monitorStatus"
          class=""
          clearable
          @change="selectChange"
        >
          <el-option
            v-for="(item,index) in monitorStatusList"
            :key="index"
            :label="item.name"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="6"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          style="width: 100%"
          placeholder="机器人状态查询"
          v-model="botStatus"
          class=""
          clearable
          @change="selectChange"
        >
          <el-option
            v-for="(item,index) in botStatusList"
            :key="index"
            :label="item.name"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-col>
      <span style="display: inline-block;width: 10px"></span>
      <vs-button
        type="info"
        class="search-btn btn box-item"
        @click="searchHandle"
      >查询</vs-button>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "queryHeader",
  data() {
    return {
      botName: '',
      status: '',
      statusList: [
        {key:0,name:'离线'},
        {key:1,name:'在线'}
      ],
      monitorStatus: '',
      monitorStatusList:[
        {key:0,name:'未监听'},
        {key:1,name:'监听中'}
      ],
      botStatus: '',
      botStatusList:[
        {key:0,name:'禁用'},
        {key:1,name:'启用'}
      ],
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
  },
  methods: {
    phFileter(data){
      return this.$t(data)
    },
    selectChange(){
      this.$emit('toQuery');
    },
    searchHandle(){
      this.$emit('toQuery');
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .header-sub-item {
    width: 100%;
  }
}
</style>
